import { render, staticRenderFns } from "./cardDistribut.vue?vue&type=template&id=387cc120&scoped=true&"
import script from "./cardDistribut.vue?vue&type=script&lang=js&"
export * from "./cardDistribut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387cc120",
  null
  
)

export default component.exports